'use client';

import classNames from 'classnames';
import { useAtomValue } from 'jotai';
import styles from './Consultation.module.scss';
import { theme } from '../../../store/theme';
import AnimatedTitle from '../../../components/AnimatedTitle';
import ConsultationForm, { SubmitType } from './ConsultationForm';

interface IAltView {
  title: string,
  description: string,
  className?: string;
  formId?: string;
}

const AltView = ({
  title,
  description,
  className,
  formId,
}: IAltView) => {
  const appTheme = useAtomValue(theme);

  return (
    <div className={classNames(styles.altViewWrapper, 'container')}>
      <div className={styles.altContentWrapper}>
        <div className={styles.altContent}>
          <h2 className={classNames(styles.title, 'title3')}><AnimatedTitle title={title} /></h2>
          <p className={styles.description}>{description}</p>
          <ConsultationForm
            type={SubmitType.NEWSLETTER}
            className={className}
            formId={formId}
          />
          <svg className={styles.planeIcon}>
            <use
              href={`/media/consultation/paper_plane_${appTheme}.svg#paper-plane-${appTheme}`}
              xlinkHref={`/media/consultation/paper_plane_${appTheme}.svg#paper-plane-${appTheme}`}
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default AltView;
